const REGEX_ONETRUST_CONSENT_COOKIE = /OptanonConsent[\S]*/;
// CONSENT 1 = Granted, 0 = Rejected

/**
 * @param {string} category
 * @returns {string}
 */

export const getOptamonCookieConsent = (category) => {
  let consent = '';
  if (typeof document !== 'undefined') {
    const oneTrustCookie = document.cookie.match(REGEX_ONETRUST_CONSENT_COOKIE);
    if (oneTrustCookie && oneTrustCookie[0]) {
      const consentRegex = new RegExp(`${category}%3A[0|1]`);
      const categoryCookie = oneTrustCookie[0].match(consentRegex);
      if (categoryCookie && categoryCookie[0]) {
        // The last digit of the category in the cookie means accepted or rejected consent (1 or 0)
        consent = categoryCookie[0].charAt(categoryCookie[0].length - 1);
      }
    } else {
      consent = '0';
    }
  }
  return consent;
};
/**
 * List of OneTrust cookie categories.
 *
 * These categories are defined by OneTrust and used to classify cookies according to their purpose.
 * Refer to the official OneTrust categorization dashboard for any changes or updates.
 *
 * https://app-de.onetrust.com/cookies/categorizations?tab=Categories
 */
export const ONE_TRUST_COOKIES_CATEGORIES = {
  REQUIRED: 'C0001',
  PERFORMANCE: 'C0002',
  FUNCTIONAL: 'C0003',
  MARKETING: 'C0004',
  SOCIAL_MEDIA: 'C0005',
  ANALYTICAL: 'C0013',
  THIRD_PARTY: 'C0014',
};
